// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__24Yal","info":"PatientInfo_info__2KwGS"};